<script setup lang="ts">
import PcSideNav from "~/components/page/PcSideNav.vue";

const user = useUserStore()
</script>

<template>
    <div class="min-h-screen flex flex-col md:flex-row">
      <div class="hidden lg:flex md:flex-shrink-0 md:w-1/3 md:h-screen md:sticky md:top-0">
        <LoginSide v-if="!user.isLoggedIn" />
        <PcSideNav v-else />
      </div>

      <div class="flex-1 flex flex-col md:border-x-2 border-gray-200 dark:border-brand-500 max-w-screen-lg overflow-x-hidden md:mx-auto overflow-y-auto">
        <slot />
      </div>

      <div class="hidden lg:flex md:flex-shrink-0 md:w-1/3 md:h-screen md:sticky md:top-0">
        <RightSide />
      </div>
    </div>
</template>